// Отрисовка открытых диалогов (registry.dialogs через dialogHost) и уведомлений (toastHost).
import { useSyncExternalStore } from 'react';
import { dialogHost, toastHost, ctx } from '../core/ctx';
import { registry } from '../core/registry';
import { Icon } from './icons';

export function DialogHost() {
  const open = useSyncExternalStore(dialogHost.subscribe, dialogHost.get);
  return (
    <>
      {open.map((d) => {
        const spec = registry.dialogs.get(d.id);
        if (!spec) return null;
        const C = spec.component;
        return <C key={d.key} ctx={ctx} props={d.props as Record<string, any>} close={(r?: unknown) => dialogHost.close(d.key, r)} />;
      })}
    </>
  );
}

export function ToastHost() {
  const list = useSyncExternalStore(toastHost.subscribe, toastHost.get);
  return (
    <div className="toasts" aria-live="polite">
      {list.map((t) => (
        <div key={t.key} className={'toast toast-' + t.kind} data-testid="toast" onClick={() => toastHost.dismiss(t.key)}>
          <Icon name={t.kind === 'error' ? 'error' : t.kind === 'warn' ? 'warn' : t.kind === 'ok' ? 'ok' : 'info'} size={16} />
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  );
}
